import styled from 'styled-components';

export const StyledLegend = styled.legend`
  font-size: 1rem;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
`;

export const HorizontalRule = styled.div`
  margin-top: ${({ theme }) => theme.spacing.large};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
  border-bottom: 1px solid ${({ theme }) => theme.palette.border};
`;
